import { actions } from './patientIndicator/actions'
import { getters } from './patientIndicator/getters'
import { state } from './patientIndicator/state'
import { mutations } from './patientIndicator/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
